import { render, staticRenderFns } from "./RptReceivePaymentResult.vue?vue&type=template&id=b905ee4c&"
import script from "./RptReceivePaymentResult.vue?vue&type=script&lang=ts&"
export * from "./RptReceivePaymentResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports